const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Izdari savu izvēli šeit.",
  seeAll: "Skatīt visu",
  clear: "Notīrīt",
  back: "Atpakaļ",
  save: "SAGLABĀT",
  close: "Aizvērt",
  of: "No",
  to: "līdz",
  copyrights: "© {date} Bridgestone Solutions. Visas tiesības aizsargātas.",
  pageNotFound: "Lapa nav atrasta",
  accessDenied: "Piekļuve liegta",
  search: "Meklēt",
  year: "Gads",
  buttons: {
    loading: "Notiek ielāde...",
    export: "Eksportēt",
    delete: "Dzēst",
    save: "SAGLABĀT",
    cancel: "Atcelt",
    next: "Nākamais",
    back: "Atpakaļ",
    skip: "Izlaist",
    send: "SAGLABĀT",
    readNow: "Skaityk dabar",
    pointsList: "Punktu saraksts",
    clear: "Notīrīt",
    more: " Vairāk",
    close: "Aizvērt",
    reportError: "Ziņot par kļūdu",
    accept: "Pieņemt",
    download: "Lejupielādēt",
    downloadAll: "Lejupielādēt visu",
    selectAll: "Atlasīt visu",
    deselectAll: "Noņemt atlasi",
    downloadSelection: "Lejupielādēt atlasīto",
    dealerInfoDownload: "Lejupielādēt",
    toTheBasket: "Uz grozu",
    toOrderDelivery: "Turpināt uz piegādes adresi",
    discover: "Atklāt",
    newAddress: "Izveidot jaunu piegādes adresi",
    selectAddressBtn: "Izvēlēties piegādes adresi",
    toOrderSummary: "Uz pasūtījuma pārskatu",
    placeOrder: "Saistošs pasūtījums",
    toDashboard: "Uz sākumlapu",
    newOrder: "Jauns pasūtījums",
    userOrders: "Uz jūsu pasūtījumiem",
    toSearch: "Meklēt",
    select: "Izvēlēties",
    moreCustomerNumbers: "+ PIEVIENOT VAIRĀK KLIENTU NUMURU",
    loadMore: "Ielādēt vēl",
    toStaffDashboard: "Uz paneli",
    toQuiz: "Uz viktorīnu",
    vouchers: "Vaučeri",
    exchangeVoucher: "Izmantot vaučera kodu",
    confirm: "Apstiprināt",
    sharePoints: "Kopīgot punktus",
    create: "Izveidot",
    update: "Atjaunināt",
    toBDrive: "Uz B-Drive",
    preview: "Priekšskatījums",
    clickHere: "Skatīt detaļas",
    setFilters: "Lūdzu, iestatiet <b>ne vairāk kā vienu filtru katrā kolonnā</b>",
    all: "Visi",
  },
  tooltips: {
    info: "Vai nepieciešama palīdzība? +371 29 16 22 12",
  },
  confirmation: {
    header: "Nepieciešams apstiprinājums",
    message: "Vai tiešām vēlaties dzēst šo ierakstu?",
  },
  nav: {
    consents: "Piekrišanas",
    dashboard: "Skums",
    accountDashboard: "Panelis",
    account: "Mans Profils",
    mailbox: "Iesūtne",
    singleMailbox: "Ziņojumi",
    stammdaten: "Pamatdati",
    news_feeds: "Jaunumi",
    pointsOverview: "Punktu pārskats",
    rewardsOverview: "Punktu pārskats",
    about: "Par BS Plus",
    service_number: "Sazināties ar servisu",
    shop: "Atlīdzības veikals",
    salesPromotions: "Pārdošanas akcijas",
    promotions: "Mans konts",
    shopCategory: "Atlīdzību veikals",
    productDetails: "Produkta informācija",
    userOrders: "Lietotāja pasūtījumi",
    shoppingCart: "Iepirkumu grozs",
    orderSummary: "Pasūtījuma pārskats",
    orderComplete: "Pasūtījums pabeigts",
    text_page: "Statiska lapa",
    staff: "Servisa panelis",
    onlineTrainings: "Tiešsaistes apmācības",
    trainings: "Apmācības",
    training: "Apmācība",
    trainingForm: "Apmācību forma",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cenu lapas un brošūras",
    investment: "Investiciju atbalsts",
    media: "Mediji",
    medias: "Mediji",
    contact_service: "Kontakti un serviss",
    productInfo: "PRODUKTA INFORMĀCIJA",
    bDrive: "Produktu attēli",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Dalības noteikumi",
    first_stop: "Bridgestone riepu garantija",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Skums",
    accountDashboard: "Panelis",
    account: "Mans Profils",
    mailbox: "Iesūtne",
    singleMailbox: "Ziņojumi",
    stammdaten: "Pamatdati",
    news_feeds: "Jaunumi",
    pointsOverview: "Punktu pārskats",
    rewardsOverview: "Punktu pārskats",
    about: "Par BS Plus",
    service_number: "Sazināties ar servisu",
    shop: "Atlīdzības veikals",
    salesPromotions: "Pārdošanas akcijas",
    promotions: "Mans konts",
    shopCategory: "Atlīdzību veikals",
    productDetails: "Produkta informācija",
    userOrders: "Lietotāja pasūtījumi",
    shoppingCart: "Iepirkumu grozs",
    orderSummary: "Pasūtījuma pārskats",
    orderComplete: "Pasūtījums pabeigts",
    staff: "Servisa panelis",
    onlineTrainings: "Tiešsaistes apmācības",
    trainings: "Apmācības",
    training: "Apmācība",
    trainingForm: "Apmācību forma",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cenu lapas un brošūras",
    investment: "Investiciju atbalsts",
    media: "Mediji",
    medias: "Mediji",
    contact_service: "Kontakti un serviss",
    productInfo: "PRODUKTA INFORMĀCIJA",
    bDrive: "Produktu attēli",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Dalības noteikumi",
    first_stop: "Bridgestone riepu garantija",
    payouts: "Payouts",
},
  menu: {
    account: "Mans Profils",
    plus: 'Par Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Pārdošanas atbalsts",
    mailbox: "Iesūtne",
    about: "Par BS Plus",
    trainingAndCourses: "Apmācības un kursi",
    externalTraining: "Ārējā apmācība",
    productInfo: "Produkta informācija",
    productBrochures: "Produktu brošūras",
    priceLists: "Cenu saraksti",
    price: "Cena",
    complaintForm: "Sūdzības forma",
    sales_support: "Pārdošanas atbalsts",
    contact_service: "Kontakti un serviss",
    logOut: "Izrakstīties",
    news: "Jaunumi",
    news_feeds: "Jaunumi",
    service_number: "Sazināties ar servisu",
    salesPromotions: "Pārdošanas akcijas",
    shop: "Veikals",
    onlineTrainings: "Tiešsaistes apmācības",
    trainings: "Apmācības",
    brochure_prices: "Cenu lapas un brošūras",
    media: "Mediji",
    medias: "Mediji",
    stammdaten: "Pamatdati",
    preislisten: "Cenu saraksti",
  },
  validation: {
    requiredField: "Obligāts lauks",
  },
  sortBy: {
    default: "Kārtot pēc",
    desc: "Kārtot pēc: Jaunākie",
    asc: "Kārtot pēc: Vecākie",
    name: "Nosaukums",
    date: "Datums",
    choiceBy: "Kārtot",
  },
  month: {
    1: "janvāris",
    2: "februāris",
    3: "marts",
    4: "aprīlis",
    5: "maijs",
    6: "jūnijs",
    7: "jūlijs",
    8: "augusts",
    9: "septembris",
    10: "oktobris",
    11: "novembris",
    12: "decembris"
  },
};


export default {
  messages,
};
